import { Navigate, useParams } from 'react-router';

/**
 * 정산 결과 페이지는 입력 페이지(/cost/:meetingId)와 통합되었음.
 * 기존 링크/푸시 deeplink 호환을 위해 thin redirect 만 유지.
 */
export const CostResult = () => {
    const { meetingId } = useParams();
    return <Navigate to={`/cost/${meetingId}`} replace />;
};
